import { Box, styled } from '@material-ui/core';
import { styled as styledBase } from 'styled-components';
import { SRoundedContainer } from '@setvi/shared/components';
import { CloseModalIcon } from 'pages/quotes/icons';

export const ProductEnhancerContainer = styled(SRoundedContainer)(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(4),
    flex: 1,
    padding: theme.spacing(4),
    paddingBottom: 0,
    boxSizing: 'border-box'
  })
);

export const FieldsGrid = styledBase('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 20
});

export const FieldCell = styledBase('div').withConfig({
  shouldForwardProp: prop => prop !== 'gridColumn' && prop !== 'spanRows'
})<{
  gridColumn: string;
  spanRows?: number;
}>(({ gridColumn, spanRows }) => ({
  gridColumn,
  ...(spanRows ? { gridRow: `1 / span ${spanRows}` } : {})
}));

export const BaseTagFieldCard = styled(SRoundedContainer)({
  boxSizing: 'border-box',
  width: '100%',
  padding: '12px 16px',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
  gap: 8
});

// will use it when tags are available
export const BaseTagFieldChip = styled(SRoundedContainer)({
  boxSizing: 'border-box',
  padding: '4px 8px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 4,
  borderRadius: '8px'
});

// will use it when tags are available
export const BaseTagFieldCloseIcon = styled(CloseModalIcon)({
  fontSize: 16
});

export const BaseLabelValueFieldCard = styled(SRoundedContainer)(
  ({ theme }) => ({
    boxSizing: 'border-box',
    width: '100%',
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  })
);

export const BaseLabelValueFieldRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3)
}));

export const BaseLabelFieldCard = styled(SRoundedContainer)(({ theme }) => ({
  boxSizing: 'border-box',
  width: '100%',
  padding: theme.spacing(3),
  flexBasis: '50%',
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  height: 'max-content'
}));
